var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-85.333 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(80) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1b0073",
    d: "M-128 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60006",
    d: "M-128 128h768v256h-768z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#e60000",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.207557,
    d: "M93.251 248.065h325.473v52.63H93.251z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 280l-5 15h320l-5-15H220z",
    transform: "matrix(1.0514 0 0 .82556 -138.285 69.541)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(1.27557 0 0 .82556 37.621 69.542)",
    strokeWidth: 1.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.64243 0 0 .82556 211.19 69.542)",
    strokeWidth: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.4152 0 0 .82556 272.558 69.542)",
    strokeWidth: 2.024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(1.3409 0 0 .82556 -106.058 69.541)",
    strokeWidth: 1.098
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3056065,
    d: "M91.424 247.27h329.137v12.384H91.424z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2292311,
    d: "M349.646 248.179h64.506v52.422h-64.506z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.8308405000000001,
    d: "M395.79 272.745h6.451v27.852h-6.45zM367.408 272.745h6.45v27.852h-6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.67356 0 0 .82556 73.91 69.541)",
    strokeWidth: 1.554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.42245 0 0 .82556 141.925 69.541)",
    strokeWidth: 1.956
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2643225,
    d: "M221.675 248.065h67.968v52.63h-67.968z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.0733840000000001,
    d: "M275.83 272.74h6.45v27.853h-6.45zM230.944 272.738h6.454v27.852h-6.454z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.980495,
    d: "M239.53 235.33h32.914v65.352h-32.913z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.0733840000000001,
    d: "M264.219 272.739h6.45v27.852h-6.45zM242.555 272.74h6.455v27.852h-6.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.18 217.13l13.471 22.98 14.264-22.98H358.18z",
    transform: "matrix(1.0321 0 0 .87371 -128 56.123)",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2168459,
    d: "M375.242 248.065h18.285v65.012h-18.285z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2158138,
    d: "M378.286 248.065h12.178v65.012h-12.178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(1.27568 0 0 .82556 -215.159 69.542)",
    strokeWidth: 1.123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.59975 0 0 .82556 -34.228 69.542)",
    strokeWidth: 1.637
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 280l-5 15h60l-5-15h-50z",
    transform: "matrix(.38267 0 0 .82556 24.297 69.542)",
    strokeWidth: 2.049
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2271669,
    d: "M96.905 248.065h63.998v52.63H96.905z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.8308405000000001,
    d: "M109.383 272.747h6.45V300.6h-6.45zM139.056 272.748h6.45V300.6h-6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2168459,
    d: "M118.847 248.065h18.286v65.012h-18.286z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2158138,
    d: "M121.882 248.065h12.177v65.012h-12.177z"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3200558999999998,
    d: "M87.77 235.68h336.445v12.383H87.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1pt",
    d: "M187.5 328.56h406.25v17.5H187.5z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.197,
    d: "M226.25 284.81h327.5v17.5h-327.5z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.215,
    d: "M221.25 288.56h337.5v17.5h-337.5z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1pt",
    d: "M187.5 328.56h406.25v17.5H187.5z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.249,
    d: "M212.5 298.56h356.25v17.5H212.5z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.292,
    d: "M200 311.06h381.25v17.5H200z",
    transform: "matrix(1.0802 0 0 .9098 -165.977 50.86)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.373,
    d: "M287.5 283.56h18.75v62.5H287.5z",
    transform: "matrix(.97521 0 0 .89163 -161.523 57.156)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.121,
    d: "M290.62 283.56h12.5v62.5h-12.5z",
    transform: "matrix(.97521 0 0 .89163 -161.523 57.156)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.373,
    d: "M287.5 283.56h18.75v62.5H287.5z",
    transform: "matrix(.97521 0 0 .89163 94.47 57.156)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.121,
    d: "M290.62 283.56h12.5v62.5h-12.5z",
    transform: "matrix(.97521 0 0 .89163 94.47 57.156)"
  }))), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2395521,
    d: "M249.233 248.065h14.696v117.64h-14.696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.92 220.3l.184-36.915s3.362 7.236 29.512 8.821c24.749-.937 28.848-5.362 29.969-9.284l-1.025 37.515-58.64-.137z",
    transform: "matrix(.97394 0 0 .87371 141.574 56.123)",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.428 0 0 .30959 228.657 146.27)",
    strokeWidth: 3.528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.55638 0 0 .43342 182.114 136.848)",
    strokeWidth: 2.615
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 280.52c.792 0 30.112 52.301 0 53.093-30.112.793 0-51.508 0-53.093z",
    transform: "matrix(.40719 0 0 .40808 383.966 46.902)",
    strokeWidth: 3.383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.32914 0 0 .16252 264.684 154.57)",
    strokeWidth: 5.963
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.16902 0 0 .16252 322.73 157.278)",
    strokeWidth: 8.321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .2167 261.461 154.105)",
    strokeWidth: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .2167 261.461 159.523)",
    strokeWidth: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.3291 0 0 .4334 264.684 130.58)",
    strokeWidth: 3.651
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.3291 0 0 .4334 264.684 141.415)",
    strokeWidth: 3.651
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .54176 261.461 135.069)",
    strokeWidth: 3.223
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.32914 0 0 .32505 264.684 180.265)",
    strokeWidth: 4.216
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.428 0 0 .30959 -26.964 143.958)",
    strokeWidth: 3.528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.55638 0 0 .43342 -73.507 134.534)",
    strokeWidth: 2.615
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 220.3l.184-36.915s3.362 7.236 29.512 8.821c24.749-.937 28.848-5.362 29.969-9.284l-1.025 37.515-58.64-.137z",
    transform: "matrix(.97394 0 0 .87371 -111.857 56.123)",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 280.52c.792 0 30.112 52.301 0 53.093-30.112.793 0-51.508 0-53.093z",
    transform: "matrix(.40719 0 0 .40808 127.97 46.902)",
    strokeWidth: 3.383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.32914 0 0 .16252 8.688 154.57)",
    strokeWidth: 5.963
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.16902 0 0 .16252 66.734 157.278)",
    strokeWidth: 8.321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .2167 5.466 154.105)",
    strokeWidth: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .2167 5.466 159.523)",
    strokeWidth: 5.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.3291 0 0 .4334 8.688 130.58)",
    strokeWidth: 3.651
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.3291 0 0 .4334 8.688 141.415)",
    strokeWidth: 3.651
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-.878-16.666s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334l-.878 16.666H330.92z",
    transform: "matrix(.33803 0 0 .54176 5.466 135.069)",
    strokeWidth: 3.223
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.32914 0 0 .32505 8.688 180.265)",
    strokeWidth: 4.216
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 6.449,
    height: 12.898,
    width: 85.039,
    y: 226.28,
    x: 329.53,
    strokeWidth: 1.226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24-212.6l1.093-56.693s-3.28 13.906-13.123 13.906H190.29c-9.843 0-13.124-13.906-13.124-13.906l1.093 56.693h174.98z",
    transform: "matrix(.5 0 0 .75 239.17 393.31)",
    strokeWidth: 1.579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.4 0 0 .57434 194.88 174.23)",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.48 0 0 .57434 159.45 186.23)",
    strokeWidth: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.999 20.288-9.332c-3.27-6.333-27.29-18.36-61.81-31.08-24.29-5.905 31.26-26.346-21.07-27.709-48.02.757-5.42 23.318-21.07 28.618-38.84 11.81-69.33 23.838-72.6 30.171-3.27 6.334 20.29 9.332 20.29 9.332l.408 25.61h135.15z",
    transform: "matrix(.12985 0 0 .26106 314.17 134.08)",
    strokeWidth: 6.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.28332 0 0 .46992 246.55 156.75)",
    strokeWidth: 3.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.34 0 0 .46992 221.46 166.57)",
    strokeWidth: 2.877
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.18333 0 0 .31908 290.85 149.49)",
    strokeWidth: 4.755
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.22 0 0 .31908 274.61 156.16)",
    strokeWidth: 4.341
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.12985 0 0 .26106 314.53 139.78)",
    strokeWidth: 6.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.49 70.219l.41-25.609s23.557-2.998 20.288-9.332c-3.27-6.333-31.604 7.986-31.604 7.986h-113.34s-28.335-14.32-31.604-7.986c-3.269 6.334 20.288 9.332 20.288 9.332l.408 25.609h135.15z",
    transform: "matrix(.15583 0 0 .26106 303.03 145.24)",
    strokeWidth: 5.702
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.17717 0 0 .17997 307.82 126.336)",
    strokeWidth: 5.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.24803 0 0 .17997 282.14 132.335)",
    strokeWidth: 5.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.28346 0 0 .23996 269.29 130.316)",
    strokeWidth: 4.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.35433 0 0 .29995 243.6 130.697)",
    strokeWidth: 3.528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.18 217.13l13.471 22.98 14.264-22.98H358.18z",
    transform: "matrix(.92308 0 0 .67386 28.619 57.554)",
    strokeWidth: 1.458
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.4252 0 0 .33427 217.91 135.867)",
    strokeWidth: 3.051
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.18 217.13l13.471 22.98 14.264-22.98H358.18z",
    transform: "matrix(1 0 0 .84654 0 37.089)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.46063 0 0 .41993 205.07 135.488)",
    strokeWidth: 2.615
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.92 208.56l-18.42-20.45c6.141-5.303 17.543 3.789 17.543 3.789s6.14-23.485 32.457-33.334c26.316 9.849 32.456 33.334 32.456 33.334s11.403-9.092 17.544-3.789l-18.422 20.455h-63.157z",
    transform: "matrix(.46063 0 0 .41993 205.07 152.762)",
    strokeWidth: 2.615
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.5 272.743h6.45v27.852h-6.45zM188.432 272.74h6.45v27.853h-6.45zM178.11 272.74h6.451v27.852h-6.45zM295.305 272.742h6.451v27.852h-6.45zM339.17 272.74h6.45v27.852h-6.45zM317.238 272.739h6.45v27.852h-6.45zM306.917 272.738h6.45v27.852h-6.45zM327.559 272.738h6.45v27.852h-6.45zM210.364 272.742h6.45v27.852h-6.45zM198.753 272.74h6.45v27.852h-6.45z",
    strokeWidth: 1.0733840000000001
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.273d895ed2dec4f86c378568e7c52018.svg";
export { ForwardRef as ReactComponent };